import { useEffect, useState, useCallback, useMemo } from "react";
import LoadingInComponent from "../../Components/LoadingInComponent";
import Button from "../../Components/Button";
import {
  Add,
  ArrowDown2,
  ArrowUp2,
  ExportSquare,
  ImportCurve,
  ImportSquare,
} from "iconsax-react";
import GuestListTable from "../../Components/Tables/GuestListTable";
import axios from "axios";
import { useToast } from "../../Components/Toast";
import {
  CREATE_DIETARY_API,
  CREATE_TABLE_API,
  EXPORT_GUEST_API,
  EXPORT_HOTEL_SUBMISSION_API,
  EXPORT_GUEST_LIST_TEMPLATE,
  GUEST_LIST_API,
  TAG_OPTIONS_API,
  ALL_TABLE_OPTIONS_API,
} from "../../Constant/api";
import Modal from "../../Components/Modal";
import { useNavigate } from "react-router-dom";
import { GUEST_ADD, GUEST_BULK_EDIT, GUEST_BULK_PREVIEW } from "../../Router/path";
import FileUpload from "../../Components/FileUpload";
import fileDownload from "js-file-download";
import Breadcrumb from "../../Components/Breadcrumb";
import { AnimatePresence, motion as m } from "framer-motion";
import Can from "../../Components/Can";
import { statusOptions } from "../../Constant/options";

const GuestListPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchCleared, setIsSearchCleared] = useState(false);
  const [loading, setLoading] = useState(false);
  const [guestList, setGuestList] = useState([]);
  const [guestListMeta, setGuestListMeta] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [perPage, setPerPage] = useState(10);
  const [missingDietary, setMissingDietary] = useState(null);
  const [selectedMissingDietary, setSelectedMissingDietary] = useState([]);
  const [missingTable, setMissingTable] = useState(null);
  const [selectedMissingTable, setSelectedMissingTable] = useState([]);
  const [rowErrors, setRowErrors] = useState(null);
  const [url, setUrl] = useState("");
  const [sortOrder, setSortOrder] = useState("desc");
  const [sortBy, setSortBy] = useState("id");
  const [importOpen, setImportOpen] = useState(false);
  const [tagOptions, setTagOptions] = useState([]);
  const [tableOptions, setTableOptions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedTables, setSelectedTables] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);

  const navigate = useNavigate();
  const { toast } = useToast();

  const handleSortOrderChange = (field) => {
    if (sortBy === field) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(field);
      setSortOrder("asc");
    }
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      fetchGuestList();
    }
  };

  const clearFilter = () => {
    setSearchTerm("");
    setSelectedTables([]);
    setSelectedTags([]);
    setSelectedStatus([]);
    setIsSearchCleared(true);
  };

  const toggleModal = () => {
    setShowModal(!showModal);
    setMissingDietary(null);
    setMissingTable(null);
    setRowErrors(null);
  };

  const handlePerPageChange = (e) => {
    setPerPage(e.target.value);
    fetchGuestList(1, e.target.value);
  };

  const handleFileUpload = (data) => {
    if (data.row_errors && data.row_errors.length > 0) {
      setRowErrors(data.row_errors);
      setUrl(data.url);
    }
    if (data.missing_dietary && data.missing_dietary.length > 0) {
      setMissingDietary(data.missing_dietary);
      setUrl(data.url);
    }
    if (data.missing_table && data.missing_table.length > 0) {
      setMissingTable(data.missing_table);
      setUrl(data.url);
    }
    if (
      (!data.missing_dietary || data.missing_dietary.length === 0) &&
      (!data.missing_table || data.missing_table.length === 0) &&
      (!data.row_errors || data.row_errors.length === 0) &&
      data.url
    ) {
      navigate(GUEST_BULK_PREVIEW, { state: { url: data.url } });
    }
  };

  const handlePageClick = (e) => {
    const selectedPage = e.selected + 1;
    if (selectedPage !== guestListMeta.page) {
      fetchGuestList(selectedPage);
    }
  };

  const fetchGuestList = useCallback(
    async (page = 1, perPageValue = perPage) => {
      setLoading(true);
      axios
        .get(GUEST_LIST_API, {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          params: {
            eventId: sessionStorage.getItem("event_id"),
            page: page,
            perPage: perPageValue,
            search: searchTerm,
            tags: selectedTags,
            tables: selectedTables,
            sortBy,
            sortOrder: sortOrder,
            statuses: selectedStatus,
          },
        })
        .then((res) => {
          setLoading(false);
          setGuestList(res.data.data);
          setGuestListMeta(res.data.meta.pagination);
        })
        .catch((err) => {
          setLoading(false);
          toast("Failed to fetch guest list.", "error");
          console.error(err);
        });
    },
    [
      perPage,
      searchTerm,
      sortBy,
      sortOrder,
      selectedTags,
      selectedTables,
      selectedStatus,
      toast,
    ]
  );

  const downloadImportTemplate = async () => {
    axios
      .get(EXPORT_GUEST_LIST_TEMPLATE, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, "guest_list_template.xlsx");
      })
      .catch((err) => {
        toast("Failed to fetch guest list template.", "error");
        console.log(err);
      });
  };

  const handleMissingDietarySubmit = () => {
    setLoading(true);
    if (selectedMissingDietary.length > 0) {
      axios
        .post(
          CREATE_DIETARY_API,
          {
            event_id: sessionStorage.getItem("event_id"),
            name: selectedMissingDietary,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
            },
          }
        )
        .then(() => {
          setLoading(false);
          toast("Missing dietary created successfully.", "success");
          setMissingDietary(null);
          setSelectedMissingDietary([]);
          if (!missingTable) {
            navigate(GUEST_BULK_PREVIEW, { state: { url: url } });
          }
        })
        .catch((err) => {
          setLoading(false);
          toast("Failed to create missing dietary.", "error");
          console.log(err);
        });
    } else {
      setLoading(false);
      setMissingDietary(null);
      setSelectedMissingDietary([]);
      if (!missingTable) {
        navigate(GUEST_BULK_PREVIEW, { state: { url: url } });
      }
    }
  };

  const handleMissingTableSubmit = () => {
    setLoading(true);
    if (selectedMissingTable.length > 0) {
      axios
        .post(
          CREATE_TABLE_API,
          {
            event_id: sessionStorage.getItem("event_id"),
            name: selectedMissingTable,
            pax: 10,
            is_multi: false,
          },
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
            },
          }
        )
        .then(() => {
          setLoading(false);
          toast("Missing tables created successfully.", "success");
          setMissingTable(null);
          setSelectedMissingTable([]);
          if (!missingDietary) {
            navigate(GUEST_BULK_PREVIEW, { state: { url: url } });
          }
        })
        .catch((err) => {
          setLoading(false);
          toast("Failed to create missing tables.", "error");
          console.log(err);
        });
    } else {
      setLoading(false);
      setMissingTable(null);
      setSelectedMissingTable([]);
      if (!missingDietary) {
        navigate(GUEST_BULK_PREVIEW, { state: { url: url } });
      }
    }
  };

  const fetchTagList = useCallback(async () => {
    setLoading(true);
    axios
      .get(TAG_OPTIONS_API, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: { eventId: sessionStorage.getItem("event_id") },
      })
      .then((res) => {
        setLoading(false);
        setTagOptions(res.data.data);
      })
      .catch((err) => {
        setLoading(false);
        toast("Failed to fetch tag list.", "error");
        console.log(err);
      });
  }, [toast]);

  const fetchTableList = useCallback(async () => {
    setLoading(true);
    axios
      .get(ALL_TABLE_OPTIONS_API, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: { eventId: sessionStorage.getItem("event_id") },
      })
      .then((res) => {
        setLoading(false);
        setTableOptions(res.data.data);
      })
      .catch((err) => {
        setLoading(false);
        toast("Failed to fetch table list.", "error");
        console.log(err);
      });
  }, [toast]);

  const exportGuestList = async () => {
    toast("Exporting guest list...", "info");
    axios
      .post(
        EXPORT_GUEST_API,
        { eventId: sessionStorage.getItem("event_id") },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
            TimezoneOffset: new Date().getTimezoneOffset(),
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        fileDownload(res.data, "guest_list.xlsx");
      })
      .catch((err) => {
        toast("Failed to fetch guest list template.", "error");
        console.log(err);
      });
  };

  const exportHotelSubmission = async () => {
    toast("Exporting hotel submission...", "info");
    axios
      .post(
        EXPORT_HOTEL_SUBMISSION_API,
        { eventId: sessionStorage.getItem("event_id") },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
          },
          responseType: "blob",
        }
      )
      .then((res) => {
        const suggestedFileName = res.headers["x-suggested-filename"];
        const contentDisposition = res.headers["content-disposition"] || res.headers["Content-Disposition"];
        let fileName = suggestedFileName || "hotel_submission.xlsx";
        
        if (!suggestedFileName && contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename\*?=['"]?(?:UTF-8'')?([^;'"\n]*)['"]?/i);
          if (fileNameMatch && fileNameMatch[1]) {
            fileName = decodeURIComponent(fileNameMatch[1]);
          }
        }
        fileDownload(res.data, fileName);
      })
      .catch((err) => {
        toast("Failed to export hotel submission.", "error");
        console.log(err);
      });
  };

  const handleDropdownChange = (selectedOptions, type) => {
    if (type === "tags") {
      setSelectedTags(selectedOptions);
    } else if (type === "tables") {
      setSelectedTables(selectedOptions);
    } else if (type === "status") {
      setSelectedStatus(selectedOptions);
    }
  };

  const memoizedSelectedTags = useMemo(
    () => JSON.stringify(selectedTags),
    [selectedTags]
  );

  useEffect(() => {
    fetchGuestList();
    fetchTagList();
    fetchTableList();
  }, [
    fetchGuestList,
    fetchTagList,
    fetchTableList,
    sortOrder,
    memoizedSelectedTags,
    selectedTables,
    selectedStatus,
  ]);

  useEffect(() => {
    if (isSearchCleared && searchTerm === "") {
      fetchGuestList();
      setIsSearchCleared(false);
    }
  }, [isSearchCleared, searchTerm, fetchGuestList]);

  const breadcrumbItems = [{ label: "Guest List" }, { label: "List" }];

  return (
    <div className="flex flex-col w-full h-full overflow-hidden">
      {showModal && (
        <div className="flex w-full h-full">
          {missingDietary || missingTable || rowErrors ? (
            <div>
              {rowErrors && (
                <Modal
                  title="Import Errors"
                  description="The following errors were found in your Excel file. Please correct them and re-upload, or proceed to import only the valid rows."
                  submitLabel={"Proceed Anyway"}
                  toggleModal={toggleModal}
                  handleSubmit={() => {
                    setRowErrors(null);
                    if (!missingDietary && !missingTable) {
                      navigate(GUEST_BULK_PREVIEW, { state: { url: url } });
                    }
                  }}
                >
                  <div className="flex flex-col gap-2 max-h-[300px] overflow-y-auto border border-red-100 bg-red-50 p-4 rounded-lg">
                    {rowErrors.map((error, index) => (
                      <div key={index} className="text-red-600 text-sm">
                        • {error}
                      </div>
                    ))}
                  </div>
                </Modal>
              )}
              {missingDietary && !rowErrors && (
                <Modal
                  title="Missing Dietary"
                  description="We have noticed a few missing Dietary, please select from below that you wish to add."
                  submitLabel={"Proceed"}
                  toggleModal={toggleModal}
                  handleSubmit={() => {
                    handleMissingDietarySubmit();
                  }}
                >
                  <div className="grid grid-cols-2 lg:grid-cols-3 gap-2">
                    {missingDietary.map((dietary, index) => (
                      <div className="flex items-center gap-2" key={index}>
                        <input
                          type="checkbox"
                          value={dietary}
                          onChange={() => {
                            if (selectedMissingDietary.includes(dietary)) {
                              setSelectedMissingDietary(
                                selectedMissingDietary.filter(
                                  (d) => d !== dietary
                                )
                              );
                            } else {
                              setSelectedMissingDietary([
                                ...selectedMissingDietary,
                                dietary,
                              ]);
                            }
                          }}
                        />
                        <label>{dietary}</label>
                      </div>
                    ))}
                  </div>
                </Modal>
              )}
              {missingTable && !rowErrors && !missingDietary && (
                <Modal
                  title="Missing Table"
                  description="We have noticed a few missing Table assignments, please select from below that you wish to add."
                  submitLabel={"Proceed"}
                  toggleModal={toggleModal}
                  handleSubmit={() => {
                    handleMissingTableSubmit();
                  }}
                >
                  <div className="grid grid-cols-2 lg:grid-cols-3 w-full gap-2">
                    {missingTable.map((table, index) => (
                      <div className="flex items-center gap-2" key={index}>
                        <input
                          type="checkbox"
                          value={table}
                          checked={selectedMissingTable.includes(table)}
                          onChange={() => {
                            if (selectedMissingTable.includes(table)) {
                              setSelectedMissingTable(
                                selectedMissingTable.filter((t) => t !== table)
                              );
                            } else {
                              setSelectedMissingTable([
                                ...selectedMissingTable,
                                table,
                              ]);
                            }
                          }}
                          className="accent-[#5C4BF5] w-4 h-4"
                        />
                        <label>{table}</label>
                      </div>
                    ))}
                    <div className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={
                          selectedMissingTable.length === missingTable.length &&
                          missingTable.length > 0
                        }
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedMissingTable([...missingTable]);
                          } else {
                            setSelectedMissingTable([]);
                          }
                        }}
                        className="accent-[#5C4BF5] w-4 h-4"
                      />
                      <label>Select All</label>
                    </div>
                  </div>
                </Modal>
              )}
            </div>
          ) : (
            <Modal
              title="Import Guest List"
              description="Import a .xlsx or .csv format file."
              toggleModal={toggleModal}
            >
              <FileUpload handleChange={handleFileUpload} />
            </Modal>
          )}
        </div>
      )}
      <LoadingInComponent isLoading={loading}>
        <div className="flex flex-col w-full h-full p-[16px] md:p-[32px] no-scrollbar overflow-y-auto gap-[12px] md:gap-[24px]">
          {/* Breadcrumb */}
          <Breadcrumb items={breadcrumbItems} />

          {/* Title row */}
          <div className="flex flex-col md:flex-row w-full justify-between items-center">
            <h1 className="text-[29px]">Guest List</h1>
          </div>

          {/* Bulk upload area */}
          <Can permission="import_guest_list">
            <m.div
              className="flex flex-col w-full h-fit bg-white rounded-xl border border-[#EFF0F2]"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
            >
              <div
                className={`flex w-full items-center justify-between px-[24px] py-[16px] text-[16px] cursor-pointer ${
                  importOpen ? "border-b border-[#EFF0F2]" : ""
                }`}
                onClick={() => setImportOpen(!importOpen)}
              >
                <h2>Import Guest List</h2>
                {importOpen ? <ArrowUp2 size="20" /> : <ArrowDown2 size="20" />}
              </div>
              <AnimatePresence>
                {importOpen && (
                  <m.div
                    className="flex flex-col gap-[24px] font-normal"
                    style={{ overflow: "hidden" }}
                    initial={{ height: 0 }}
                    animate={{ height: "auto" }}
                    exit={{ height: 0 }}
                    transition={{ duration: 0.4, ease: "easeInOut" }}
                  >
                    <div className="p-[24px] flex flex-col gap-[12px]">
                      <p>
                        Easily manage your event by importing your guest list
                        directly from an Excel file. Follow the steps below to
                        download the template and upload your completed guest
                        list:
                      </p>
                      <ol
                        style={{
                          listStyleType: "decimal",
                          listStylePosition: "inside",
                        }}
                        className="border border-[#EFF0F2] rounded-xl"
                      >
                        <li className="p-[16px] border-b border-[#EFF0F2] last:border-none">
                          First,{" "}
                          <span className="font-bold">
                            Download the Excel template provided,{" "}
                          </span>
                          and fill in all necessary guest details, including
                          names, contact information, table assignments, and any
                          special dietary requirements.
                        </li>
                        <li className="p-[16px] border-b border-[#EFF0F2] last:border-none">
                          Ensuring that all information is accurate and
                          correctly formatted,{" "}
                          <span className="font-bold">
                            then save your completed template.
                          </span>
                        </li>
                        <li className="p-[16px] last:border-none">
                          Import the file by{" "}
                          <span className="font-bold">
                            selecting the Import Guest button,{" "}
                          </span>
                          uploading the Excel file, and reviewing the imported
                          data for any discrepancies.
                        </li>
                      </ol>
                      <div className="flex flex-col md:flex-row gap-[8px]">
                        <Button variant="primary" onClick={toggleModal}>
                          <ImportSquare size="16" />
                          Import Guest List
                        </Button>
                        <Button
                          variant="secondary"
                          onClick={downloadImportTemplate}
                        >
                          <ImportCurve size="16" />
                          Download Excel Template
                        </Button>
                      </div>
                    </div>
                  </m.div>
                )}
              </AnimatePresence>
            </m.div>
          </Can>

          {/* Guest list table */}
          {(!loading || guestList.length > 0) && (
            <div className="w-full">
              <GuestListTable
                withHeaderAction
                searchable
                editable
                data={guestList}
                meta={guestListMeta}
                handlePageClick={handlePageClick}
                searchTerm={searchTerm}
                handleSearch={handleSearch}
                handleKeyDown={handleKeyDown}
                handlePerPageChange={handlePerPageChange}
                perPage={perPage}
                clearFilter={clearFilter}
                sortBy={sortBy}
                sortOrder={sortOrder}
                handleSortOrderChange={handleSortOrderChange}
                tagOptions={tagOptions}
                tableOptions={tableOptions}
                statusOptions={statusOptions}
                handleDropdownChange={handleDropdownChange}
                selectedTags={selectedTags}
                selectedTables={selectedTables}
                selectedStatus={selectedStatus}
              />
            </div>
          )}
        </div>
      </LoadingInComponent>
    </div>
  );
};

export default GuestListPage;
